/*eslint new-cap:0 */
import ko from 'knockout';

export default class ViewModel {
  constructor(adViewModel = {}) {
    this.Text = adViewModel.Text;
    this.Title = adViewModel.Title;
    this.DisplayUrl = adViewModel.DisplayUrl;

    this.DestinationUrl = ko.computed(() => {
      return adViewModel.url();
    });

    this.adViewModel = adViewModel;
  }
}
